export function EditItem(Edit, id, bean, type) {

    Edit(id, bean)
        .then(() => {
            //console.log(type, "updated")
        })
        .catch(err => {
            //console.log(err.response)
        })
}